import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { IconContext } from '../context';

function IconFilePdfComponent(iconProps, ref) {
  const _useContext = useContext(IconContext),
        _useContext$prefixCls = _useContext.prefixCls,
        prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  const spin = iconProps.spin,
        className = iconProps.className;
  const props = {
    "aria-hidden": true,
    focusable: false,
    ref,
    ...iconProps,
    className: `${className ? className + ' ' : ''}${prefixCls}-icon ${prefixCls}-icon-file-pdf`
  };

  if (spin) {
    props.className = `${props.className} ${prefixCls}-icon-loading`;
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 42h26a2 2 0 0 0 2-2V13.828a2 2 0 0 0-.586-1.414l-5.828-5.828A2 2 0 0 0 31.172 6H11a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.305 21.028c.874 1.939 3.506 6.265 4.903 8.055 1.747 2.237 3.494 2.685 4.368 2.237.873-.447 1.21-4.548-7.425-2.685-7.523 1.623-7.424 3.58-6.988 4.476.728 1.193 2.522 2.627 5.678-6.266C25.699 18.79 24.489 17 23.277 17c-1.409 0-2.538.805-.972 4.028Z"
  }));
}

const IconFilePdf = /*#__PURE__*/React.forwardRef(IconFilePdfComponent);
IconFilePdf.defaultProps = {
  isIcon: true
};
IconFilePdf.displayName = 'IconFilePdf';
export default IconFilePdf;